import { FC } from "react";
import { Row } from "../../../../components/containers";
import { JustifyContent } from "../../../../components/containers/types";
import Options from "../../../../components/options";
import { IconAnimation } from "../../../../components/animation";
import { PlusIcon } from "../../../../assets/icons";
import { SearchInput } from "../../../../components/inputs";
import {
  useGeneralStore,
  usePopupStore,
  useThemeStore,
} from "../../../../stores";
import CustomerAddPopup from "../../customer-add-popup";
import useCustomerPageStore from "../../store";

const CustomersOptionsSearch: FC = () => {
  const theme = useThemeStore((s) => s.theme);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const topTags = useGeneralStore((s) => s.topTags);
  const getTagById = useGeneralStore((s) => s.getTagById);

  const { searchTerm, selectedTagOption, setSearchTerm, setSelectedTagOption } =
    useCustomerPageStore();

  const onAddClickHandler = (): void => {
    setPopupBody(<CustomerAddPopup />);
  };

  return (
    <Row
      style={{ width: "100%", minHeight: 70 }}
      justifyContent={JustifyContent.Between}
      gap={50}
      className="customers-options-search-con"
    >
      <Options
        options={[
          {
            title: "همه",
            value: { $oid: "517" },
          },
          ...topTags.map((t) => ({
            title: getTagById(t.$oid)?.name || "",
            value: getTagById(t.$oid)?._id || { $oid: "517" },
          })),
        ]}
        selectedOption={selectedTagOption}
        setSelectedOption={setSelectedTagOption}
      />
      <Row
        reverse
        style={{ width: "50%" }}
        gap={10}
        className="customers-options-search"
      >
        <IconAnimation
          Icon={PlusIcon}
          onHoverColor={theme.primary}
          className="cursor-pointer"
          width={24}
          height={24}
          onClick={onAddClickHandler}
        />
        <SearchInput
          value={searchTerm}
          setValue={setSearchTerm}
          style={{ maxWidth: 320, minWidth: 320 }}
        />
      </Row>
    </Row>
  );
};

export default CustomersOptionsSearch;
